const footerLinks = [
  {
    title: "片单分类",
    items: ["治愈番推荐", "日常系合集", "萌系动画", "温馨番单"],
  },
  {
    title: "快速导航",
    items: ["热门治愈番", "暖心片单", "追更动态", "常见问题"],
  },
];

function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/70">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-10 md:py-12">
        <div className="flex flex-col md:flex-row md:justify-between gap-8">
          <div className="max-w-sm">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-primary-600">
                小狗看番
              </span>
            </a>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              陪你慢慢挑治愈番、日常系与萌系动画。看完心里暖暖的，就是好番。
            </p>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-medium text-foreground-950">{col.title}</h4>
              <ul className="mt-3 space-y-2">
                {col.items.map((it) => (
                  <li key={it}>
                    <a
                      href="#home"
                      className="text-sm text-foreground-700 hover:text-primary-700 transition-colors"
                    >
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-medium text-foreground-950">联系我们</h4>
            <ul className="mt-3 space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-primary-600"></i>
                hello@readdy.ai
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-refresh-line text-primary-600"></i>
                片单每周更新
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-pencil-line text-primary-600"></i>
                欢迎留言推荐好番
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200/70 pt-6">
          <p className="text-xs text-foreground-600">
            © 2026 小狗看番 · 用心整理每一部治愈系动画
          </p>
          <p className="text-xs text-foreground-600">
            治愈番推荐 · 日常系合集 · 萌系动画片单
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;